// modules
import { createAction } from 'redux-actions'

export const setBillingActivityLogList = createAction(
  'SET_BILLING_ACTIVITY_LOG_LIST'
)
export const setBillingActivityLoader = createAction(
  'SET_BILLING_ACTIVITY_LOADER'
)

export const setBillingBatchList = createAction('SET_BILLING_BATCH_LIST')
export const setBatchInvoice = createAction('SET_BATCH_INVOICE')

export const setBillingInvoiceDetails = createAction(
  'SET_BILLING_INVOICE_DETAILS'
)
export const setBillingInvoiceActivityLog = createAction(
  'SET_BILLING_INVOICE_ACTIVITY_LOG'
)

export const setIsBillingLoad = createAction('SET_IS_BILLING_LOAD')
